export const SCROLL_STATUS = 'SCROLL_STATUS';
export const SCROLL_ACTIVE = 'SCROLL_ACTIVE';
export const SCROLL_RESET = 'SCROLL_RESET';
export const FOOTER_SIZE = 'FOOTER_SIZE';
export const MAIN_SIZE = 'MAIN_SIZE';